export default __webpack_public_path__ + "static/media/ork.f84f42af.webp";